import type { NextPage } from 'next';

import { Box, Container } from '@chakra-ui/react';

import { FooterNav } from '~/components/footer-nav';
import { PageLayout } from '~/components/page-layout';
import { LogInForm } from '~/features/log-in';

const LogIn: NextPage = () => {
  return (
    <PageLayout>
      <Container maxW='4xl' py={{ base: 4, lg: 16 }}>
        <LogInForm />
        <Box h={8} />
        <FooterNav colorScheme='medium-gray' />
      </Container>
    </PageLayout>
  );
};

export default LogIn;
